import {
  LeaderboardContextType,
  Sport,
  State,
  Team,
  UserPageDataTeamItem
} from '@maxpreps/apiserviceclients/apiModels';
import { ITeamContext } from '../../contexts/TeamContext';
/*
  // users api format
  userFavoriteTeams: [
    {
      schoolId,
      allSeasonId,
      seasonName
    }
  ]

  // teamContext format
  team: {
    teamId,
    allSeasonId,
    season
  }
*/

export const getFavoriteTeam = (
  userFavoriteTeams: UserPageDataTeamItem[],
  team: Team
): UserPageDataTeamItem | undefined => {
  if (!userFavoriteTeams?.length || !team) return;

  return userFavoriteTeams.find(
    t =>
      t.schoolId === team.teamId &&
      t.allSeasonId === team.allSeasonId &&
      t.seasonName === team.season
  );
};

export const getFormattedRecord = (
  wins: number,
  losses: number,
  ties: number,
  includeTiesEvenIfZero: boolean = false
) => {
  const record: number[] = [];

  record.push(wins || 0);
  record.push(losses || 0);

  if (ties > 0 || includeTiesEvenIfZero) {
    record.push(ties);
  }

  return record.join('-');
};

export const getFormattedRecordFromStandings = (
  standings: Record<string, number>[],
  prefix: string
) => {
  if (!standings) {
    return getFormattedRecord(0, 0, 0);
  }

  return getFormattedRecord(
    standings[`${prefix}Wins`],
    standings[`${prefix}Losses`],
    standings[`${prefix}Ties`]
  );
};

export const getIsCoreSport = (sportData: Sport) =>
  // TODO: (And possible buggy) since Sport doesn't return the 'standard'
  // return type for scheduleModel we're having to be hacky
  (sportData.scheduleModel as never as string) === 'Standard';

export const formatGenderSportId = (gender: string, sport: string): string =>
  typeof gender !== 'string' || typeof sport !== 'string'
    ? ''
    : `${gender},${sport.replace('&', '').replace(' ', '')}`.toLowerCase();

export const formatTeamLevel = (teamLevel: string) =>
  teamLevel?.toLowerCase().replace('jv', 'JV') ?? '';

interface IFormatSportSeasonNameOptions {
  year?: string;
  season?: string;
  schoolName?: string;
  gender?: string;
  teamLevel?: string;
  sport?: string;
}

// TODO This is just a stub, there is a lot more logic that could be added here
export const formatSportSeasonName = (
  options: IFormatSportSeasonNameOptions
) => {
  const { year, season, schoolName, gender, teamLevel, sport } = options;

  const pieces: string[] = [];
  if (schoolName) pieces.push(schoolName);
  if (season) pieces.push(season.toLowerCase());
  if (year) pieces.push(year);
  if (gender) pieces.push(gender.toLowerCase());
  if (teamLevel) pieces.push(formatTeamLevel(teamLevel));
  if (sport) pieces.push(sport.toLowerCase());

  return pieces.join(' ');
};

export const getIsMostRecentSportSeason = (
  teamContext: ITeamContext,
  isAdmin = false
) => {
  const {
    data,
    mostRecentAdminGenderSportSeasonLevel,
    mostRecentPublicGenderSportSeasonLevel
  } = teamContext;
  const testSsid = isAdmin
    ? mostRecentAdminGenderSportSeasonLevel.sportSeasonId
    : mostRecentPublicGenderSportSeasonLevel.sportSeasonId;
  return data.sportSeasonId === testSsid;
};

export const CONTEXT_TYPE_HIERARCHY = [
  LeaderboardContextType.National,
  LeaderboardContextType.State,
  LeaderboardContextType.Association,
  LeaderboardContextType.Section,
  LeaderboardContextType.Division,
  LeaderboardContextType.League
];

export const getContextTypeAlias = (
  contextType: LeaderboardContextType,
  stateData: State
): string => {
  switch (contextType) {
    case LeaderboardContextType.Section:
      return stateData.sectionAlias;
    case LeaderboardContextType.Division:
      return stateData.divisionAlias;
    case LeaderboardContextType.League:
      return stateData.leagueAlias;
    default:
      return LeaderboardContextType[contextType];
  }
};
